import axios from "axios";
import Activity from "@/interfaces/Activity";
import ActivityFields from "@/interfaces/ActivityFields";

class ActivityManager {

    async add(activity: Activity) {
        return new Promise((resolve, reject) => {
            // @ts-ignore
            window.BX24.callMethod(
                'bizproc.activity.add',
                activity.fields,
                (result: any) => {
                    if (result.error()) {
                        reject(result.error())
                    } else {
                        resolve(true)
                    }
                }
            );
        })
    }

    async delete(activity: Activity) {
        return new Promise((resolve, reject) => {
            // @ts-ignore
            window.BX24.callMethod(
                'bizproc.activity.delete',
                activity.fields,
                (result: any) => {
                    if (result.error()) {
                        reject(result.error())
                    } else {
                        resolve(true)
                    }
                }
            );
        })
    }

    async getAvailableList(): Promise<{ [activityCode: string]: ActivityFields }> {
        const response = await axios.get('/activities.json')
        return response.data
    }

    async getExistingList(): Promise<{ [activityCode: string]: string }> {
        return new Promise((resolve, reject) => {
            // @ts-ignore
            window.BX24.callMethod(
                'bizproc.activity.list',
                {},
                (result: any) => {
                    if (result.error()) {
                        reject(result.error())
                    } else {
                        const codesList: { [activityCode: string]: string } = {}

                        const list = result.data();
                        if (Array.isArray(list) && list.length > 0) {
                            list.forEach((activityCode: string) => {
                                codesList[activityCode] = activityCode
                            })
                        }

                        resolve(codesList)
                    }
                }
            )
        })
    }

    async getList(): Promise<Activity[]> {
        const activityList: Activity[] = []

        const availableListPromise = this.getAvailableList()
        const existingListPromise = this.getExistingList()

        const availableList = await availableListPromise;
        const existingList = await existingListPromise;
        console.log(existingList)

        // process available
        for (const [activityCode, fields] of Object.entries(availableList)) {
            let added = false
            if (existingList[activityCode] !== undefined) {
                added = true
                delete existingList[activityCode]
            }

            const activity = {
                available: true,
                added: added,
                adding: false,
                deleting: false,
                errorsList: [],
                fields: fields
            }

            activityList.push(activity)
        }

        /*
        // process added but unavailable
        if (Object.keys(existingList).length > 0) {
            for (const fields of Object.values(existingList)) {
                const activity = {
                    available: false,
                    added: true,
                    adding: false,
                    deleting: false,
                    fields: fields
                }
            }
        }
         */

        return activityList
    }

}

export default new ActivityManager()